export default __webpack_public_path__ + "static/media/ulc-logo.5d985047.png";